<template>
  <div>
    <Widget>
      <legend>Profil Permohonan</legend>
      <div class="row">
        <div class="col-md-6">
          <label>NIK Pemohon</label>
          <b-form-input readonly 
            v-model="form.nik_pemohon"
            v-validate="'required'"
            name="nik"
            :class="{ input: true, 'is-danger': errors.has('nik') }"
          ></b-form-input>
          <span class="text-danger" v-if="errors.has('nik')">
            {{ errors.first("nik") }}
          </span>
        </div>
        <div class="col-md-6">
          <label>NPWP Pemohon</label>
          <b-form-input readonly 
            v-model="form.npwp_pemohon"
            v-mask="'##.###.###.#-###.####'"
            v-validate="'required'"
            name="npwp"
            :class="{ input: true, 'is-danger': errors.has('npwp') }"
          ></b-form-input>
          <span class="text-danger" v-if="errors.has('npwp')">
            {{ errors.first("npwp") }}
          </span>
        </div>
        <div class="col-md-6 mt-3">
          <label>Nama Pemohon</label>
          <b-form-input readonly 
            v-model="form.nama_pemohon"
            v-validate="'required'"
            name="nama"
            :class="{ input: true, 'is-danger': errors.has('nama') }"
          ></b-form-input>
          <span class="text-danger" v-if="errors.has('nama')">
            {{ errors.first("nama") }}
          </span>
        </div>
        <div class="col-md-6 mt-3">
          <label>Jabatan Pemohon</label>
          <b-form-input readonly 
            v-model="form.jabatan_pemohon"
            v-validate="'required'"
            name="jabatan"
            :class="{ input: true, 'is-danger': errors.has('jabatan') }"
          ></b-form-input>
          <span class="text-danger" v-if="errors.has('jabatan')">
            {{ errors.first("jabatan") }}
          </span>
        </div>

        <div class="col-md-6 mt-3">
          <label>Instansi Pemohon</label>
          <b-form-input readonly 
            v-model="form.instansi_pemohon"
            v-validate="'required'"
            name="instansi"
            :class="{ input: true, 'is-danger': errors.has('instansi') }"
          ></b-form-input>
          <span class="text-danger" v-if="errors.has('instansi')">
            {{ errors.first("instansi") }}
          </span>
        </div>
        <div class="col-md-6 mt-3">
          <label>Alamat Pemohon</label>
          <b-form-textarea
            v-model="form.alamat_pemohon"
            v-validate="'required'"
            name="alamat"
            :class="{ input: true, 'is-danger': errors.has('alamat') }"
          ></b-form-textarea>
          <span class="text-danger" v-if="errors.has('alamat')">
            {{ errors.first("alamat") }}
          </span>
        </div>

        <div class="col-md-6 mt-3">
          <label>No. Handphone Pemohon</label>
          <b-form-input readonly 
            v-model="form.no_hp_pemohon"
            v-validate="'required'"
            name="no_hp"
            :class="{ input: true, 'is-danger': errors.has('no_hp') }"
          ></b-form-input>
          <span class="text-danger" v-if="errors.has('no_hp')">
            {{ errors.first("no_hp") }}
          </span>
        </div>

        <div class="col-md-6 mt-3">
          <label>No. Telepon Pemohon </label>
          <b-form-input readonly 
            v-model="form.no_telepon_pemohon"
            v-validate="'required'"
            name="no_telp"
            :class="{ input: true, 'is-danger': errors.has('no_telp') }"
          ></b-form-input>
          <span class="text-danger" v-if="errors.has('no_telp')">
            {{ errors.first("no_telp") }}
          </span>
          <div>
            <span style="font-size: 12px"
              >*Jika tidak ada, silahkan masukkan No. Handphone</span
            >
          </div>
        </div>

        <div class="col-md-6 mt-3">
          <label>Email Pemohon</label>
          <b-form-input readonly 
            v-model="form.email_pemohon"
            v-validate="'required'"
            name="email"
            :class="{ input: true, 'is-danger': errors.has('email') }"
          ></b-form-input>
          <span class="text-danger" v-if="errors.has('email')">
            {{ errors.first("email") }}
          </span>
        </div>

        <div class="col-md-6 mt-3">
          <label>Provinsi</label>
          <v-select
          disabled
            id="default-select"
            v-model="form.provinsi"
            :reduce="(data) => data.nama_provinsi"
            label="nama_provinsi"
            :options="dataProvinsi"
            @input="getKabupaten()"
            name="provinsi"
            v-validate="'required'"
            :class="{ input: true, 'is-danger': errors.has('provinsi') }"
          />
          <span class="text-danger" v-if="errors.has('provinsi')">
            {{ errors.first("provinsi") }}
          </span>
        </div>
        <div class="col-md-6 mt-3">
          <label>Kabupaten</label>
          <v-select
          disabled
            id="default-select"
            v-model="form.kabupaten"
            :reduce="(data) => data.nama_kabupaten"
            label="nama_kabupaten"
            :options="dataKabupaten"
            @input="getKecamatan()"
            name="kabupaten"
            v-validate="'required'"
            :class="{ input: true, 'is-danger': errors.has('kabupaten') }"
          />
          <span class="text-danger" v-if="errors.has('kabupaten')">
            {{ errors.first("kabupaten") }}
          </span>
        </div>
        <div class="col-md-6 mt-3">
          <label>Kecamatan</label>
          <v-select
          disabled
            id="default-select"
            v-model="form.kecamatan"
            :reduce="(data) => data.nama_kecamatan"
            label="nama_kecamatan"
            :options="dataKecamatan"
            name="kecamatan"
            v-validate="'required'"
            :class="{ input: true, 'is-danger': errors.has('kecamatan') }"
          />
          <span class="text-danger" v-if="errors.has('kecamatan')">
            {{ errors.first("kecamatan") }}
          </span>
        </div>
        <div class="col-md-6 mt-3">
          <label>Jenis Kegiatan</label>
          <b-form-input readonly 
            v-model="form.jenis_kegiatan"
            name="kegiatan"
            v-validate="'required'"
            :class="{ input: true, 'is-danger': errors.has('kegiatan') }"
          ></b-form-input>
          <span class="text-danger" v-if="errors.has('kegiatan')">
            {{ errors.first("kegiatan") }}
          </span>
        </div>
        <!-- <div class="col-md-6 mt-3">
              <label>Skala Usaha</label>
              <v-select
                id="default-select"
                v-model="form.skala_usaha"
                :options="dataSkalaUsaha"
                name="skala"
                v-validate="'required'"
                :class="{ input: true, 'is-danger': errors.has('skala') }"
              />
              <span class="text-danger" v-if="errors.has('skala')">
                {{ errors.first("skala") }}
              </span>
            </div> -->
        <!-- <div class="col-md-6 mt-3">
          <label>Reklamasi</label>
          <v-select
            id="default-select"
            v-model="form.reklamasi"
            :reduce="(data) => data.value"
            label="text"
            :options="dataReklamasi"
            name="reklamasi"
            v-validate="'required'"
            :class="{ input: true, 'is-danger': errors.has('reklamasi') }"
          />
          <span class="text-danger" v-if="errors.has('reklamasi')">
            {{ errors.first("reklamasi") }}
          </span>
        </div> -->
        <div class="col-md-6 mt-3">
          <label>Nama Perairan</label>
          <b-form-input readonly 
            v-model="form.nama_perairan"
            name="perairan"
            v-validate="'required'"
            :class="{ input: true, 'is-danger': errors.has('perairan') }"
          ></b-form-input>
          <span class="text-danger" v-if="errors.has('perairan')">
            {{ errors.first("perairan") }}
          </span>
        </div>
        <!-- <div class="col-md-6 mt-3">
          <label>PSN</label>
          <v-select
            id="default-select"
            v-model="form.psn"
            :options="dataPSN"
            name="psn"
            v-validate="'required'"
            :class="{ input: true, 'is-danger': errors.has('psn') }"
          />
          <span class="text-danger" v-if="errors.has('psn')">
            {{ errors.first("psn") }}
          </span>
        </div> -->
        <b-col md="6" class="mt-3">
          <label>Jenis Permohonan</label>
          <v-select
          disabled
            id="default-select"
            v-model="form.jenis_permohonan"
            :options="[
              'Area',
              'Pipa Air Bersih / Air Baku',
              'Pipa Selain Air Bersih / Air Baku',
            ]"
            name="Jenis Permohonan"
            v-validate="'required'"
            :class="{ 'is-invalid': errors.has('form-1.Jenis Permohonan') }"
            @input="resetPNBP"
          />
          <span class="text-danger" v-if="errors.has('Jenis Permohonan')">
            {{ errors.first("Jenis Permohonan") }}
          </span>
        </b-col>
        <b-col md="2" class="mt-3" v-if="form.jenis_permohonan == 'Area'">
          <label>Luas (ha) *</label>
          <b-form-input readonly 
            min="0"
            step=".01"
            type="number"
            name="Luas"
            :class="{
              'form-control': true,
              'is-invalid': errors.has('form-1.Luas'),
            }"
            v-model="form.luas"
          />
          <span class="text-danger" v-if="errors.has('form-1.Luas')">
            {{ errors.first("form-1.Luas") }}
          </span>
        </b-col>

        <b-col
          md="2"
          class="mt-3"
          v-if="
            form.jenis_permohonan == 'Kabel Bawah Laut' ||
            form.jenis_permohonan == 'Pipa Air Bersih / Air Baku' ||
            form.jenis_permohonan == 'Pipa Selain Air Bersih / Air Baku'
          "
        >
          <label>Panjang (Km)</label>

          <b-form-input readonly 
            min="0"
            step=".01"
            type="number"
            name="Panjang"
            :class="{
              'form-control': true,
              'is-invalid': errors.has('form-1.Panjang'),
            }"
            v-model="form.panjang_nonkonservasi"
          />
        </b-col>
        <div class="col-md-2 mt-3">
          <label>Kedalaman (mdpl)</label>
          <b-form-input readonly 
            v-model="form.kedalaman"
            type="number"
            name="kedalaman"
            v-validate="'required'"
            :class="{ input: true, 'is-danger': errors.has('kedalaman') }"
          ></b-form-input>
          <span class="text-danger" v-if="errors.has('kedalaman')">
            {{ errors.first("kedalaman") }}
          </span>
        </div>
      </div>

      <legend class="mt-5">Dukomen Permohonan</legend>
      <b-form>
        <b-row>
          
          <b-col md="6">
            <p style="font-weight: 900; font-size: 17px">Koordinat</p>
          </b-col>
          <!-- <b-col md="3">
            <b-form-group>
              <b-form-file
                placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here..."
                plain
                class="form-control"
                v-model="file_1"
                accept=".doc, .docx, .xlsx, .pdf"
              ></b-form-file>
              <span style="color: red; font-size: 12px"
                >*Ukuran File Maksimal 5MB</span
              >
            </b-form-group>
          </b-col> -->
          <b-col md="3">
            <b-form-group>
             

              <b-button
                variant="success"
                v-if="form.file_kordinat == null"
                disabled
                data-toggle="tooltip"
                data-placement="top"
                title="Tidak ada data"
                class="text-white"
                style="margin-right: 5px"
                ><i class="fa fa-download" /> Download</b-button
              >
              <a
                :href="form.file_kordinat"
                v-else
                type="button"
                class="btn btn-success"
                target="_blank"
                rel="noopener noreferrer"
                ><i class="fa fa-download" /> Download</a
              >
            </b-form-group>
          </b-col>
          <b-col md="12" class="divider-col">
            <hr class="style1" md="12" />
          </b-col>
          <div class="divider div-transparent"></div>
          <b-col md="12">
            <p style="font-weight: 900; font-size: 17px">
              Rencana Bangunan dan Instalasi di Laut
            </p>
          </b-col>
          <b-col md="6">
            <label>Tujuan</label>
            <div style="height: auto">
              <ckeditor disabled
              v-model="form.tujuan_rencana_bangun"
              :editor="wygEditor"
              v-validate="'required'"
              name="Tujuan Rencana Bangunan"
              :class="{ input: true, 'is-danger': errors.has('Tujuan Rencana Bangunan') }"
            ></ckeditor>
            <span class="text-danger" v-if="errors.has('Tujuan Rencana Bangunan')">
              {{ errors.first("Tujuan Rencana Bangunan") }}
            </span>
            </div>
          </b-col>
          <b-col md="6">
            <label>Manfaat Kegiatan</label>
            <div style="height: auto">
              <ckeditor disabled
              v-model="form.manfaat_rencana_bangun"
              :editor="wygEditor"
              v-validate="'required'"
              name="Manfaat Rencana Bangunan"
              :class="{ input: true, 'is-danger': errors.has('Manfaat Rencana Bangunan') }"
            ></ckeditor>
            <span class="text-danger" v-if="errors.has('Manfaat Rencana Bangunan')">
              {{ errors.first("Manfaat Rencana Bangunan") }}
            </span>
            </div>
          </b-col>
          <b-col md="6 mt-2">
            <label>Kegiatan Eksisting</label>
            <div style="height: auto">
              <ckeditor disabled
              v-model="form.kegiatan_eksisting_rencana_bangun"
              :editor="wygEditor"
              v-validate="'required'"
              name="Kegiatan Eksisting Rencana Bangunan"
              :class="{ input: true, 'is-danger': errors.has('Kegiatan Eksisting Rencana Bangunan') }"
            ></ckeditor>
            <span class="text-danger" v-if="errors.has('Kegiatan Eksisting Rencana Bangunan')">
              {{ errors.first("Kegiatan Eksisting Rencana Bangunan") }}
            </span>
            </div>
          </b-col>
          <b-col md="6 mt-2">
            <label>Rencana Jadwal</label>
            <div style="height: auto">
              <ckeditor disabled
              v-model="form.rencana_jadwal_rencana_bangun"
              :editor="wygEditor"
              v-validate="'required'"
              name="Rencana Jadwal Bangunan"
              :class="{ input: true, 'is-danger': errors.has('Rencana Jadwal Bangunan') }"
            ></ckeditor>
            <span class="text-danger" v-if="errors.has('Rencana Jadwal Bangunan')">
              {{ errors.first("Rencana Jadwal Bangunan") }}
            </span>
            </div>
          </b-col>
          <b-col md="6 mt-2">
            <label>Batas Area</label>
          <b-form-textarea
            v-model="form.batas_area_rencana_bangun"
            type="text"
            name="Batas Area"
            v-validate="'required'"
            :class="{ input: true, 'is-danger': errors.has('Batas Area') }"
          ></b-form-textarea>
          <span class="text-danger" v-if="errors.has('Batas Area')">
            {{ errors.first("Batas Area") }}
          </span>
          </b-col>

          <b-col md="6 mt-2">
            <label>Rencana Tapak/Siteplan</label>
            <b-row>
              <!-- <b-col md="6">
            <b-form-group>
              <b-form-file
                placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here..."
                plain
                class="form-control"
                v-model="file_2"
                accept=".doc, .docx, .xlsx, .pdf"
              ></b-form-file>
              <span style="color: red; font-size: 12px"
                >*Ukuran File Maksimal 5MB</span
              >
            </b-form-group>
          </b-col> -->
          <b-col md="6">
            <b-form-group>
              

              <b-button
                  variant="success"
                  v-if="
                    form.file_rencana_tapak_rencana_bangun == null
                  "
                  disabled
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Tidak ada data"
                  class="text-white"
                  style="margin-right: 5px"
                  ><i class="fa fa-download" /> Download</b-button
                >
                <a
                  :href="form.file_rencana_tapak_rencana_bangun"
                  v-else
                  type="button"
                  class="btn btn-success"
                  target="_blank"
                  rel="noopener noreferrer"
                  ><i class="fa fa-download" /> Download</a
                >
            </b-form-group>
          </b-col>
            </b-row>
          </b-col>

         

          <b-col md="12" class="divider-col">
            <hr class="style1" md="12" />
          </b-col>
          <b-col md="12">
            <div>
              <p style="font-weight: 900; font-size: 17px">
                Informasi Pemanfaatan Ruang Laut
              </p>
            </div>
          </b-col>
          <b-col md="6 mt-2">
            <label>Informasi Pemanfaatan Ruang Laut di sekitar Area Permohonan</label>
            <div style="height: auto">
              <ckeditor disabled
              v-model="form.informasi_prl"
              :editor="wygEditor"
              v-validate="'required'"
              name="Informasi Pemanfaatan Ruang Lau"
              :class="{ input: true, 'is-danger': errors.has('Informasi Pemanfaatan Ruang Lau') }"
            ></ckeditor>
            <span class="text-danger" v-if="errors.has('Informasi Pemanfaatan Ruang Lau')">
              {{ errors.first("Informasi Pemanfaatan Ruang Lau") }}
            </span>
            </div>
          </b-col>
          <b-col md="12" class="divider-col">
            <hr class="style1" md="12" />
          </b-col>
          <b-col md="12">
            <div>
              <p style="font-weight: 900; font-size: 17px">
                Data kondisi terkini lokasi dan sekitarnya (ekosistem,
                hidrografi, dan oseanografi)
              </p>
            </div>
          </b-col>
          <!-- <b-col md="12" class="divider-col">
                            <hr class="style1" md="12">
                        </b-col> -->
          <b-col md="12">
            <div class="hr-sect">Ekosistem Sekitar</div>
          </b-col>
          <!-- <b-col md="3">
                        </b-col>
                        <b-col md="4">
                        </b-col> -->
          <!-- <b-col md="12" class="divider-col">
                            <hr class="style1" md="12">
                        </b-col> -->
          <b-col md="6">
            <div>Mangrove</div>
          </b-col>
          <b-col md="6">
            <div class="form-check form-switch">
                    <input
                    disabled
                      v-model="form.ada_mangrove"
                      class="form-check-input"
                      type="checkbox"
                      id="flexSwitchCheckDefault2"
                    />
                    <label
                      class="form-check-label"
                      for="flexSwitchCheckDefault2"
                      >{{
                        form.ada_mangrove
                          ? "Ada"
                          : "Tidak Ada"
                      }}</label
                    >
                  </div>
          </b-col>
          <b-col md="12" class="divider-col">
            <hr class="style1" md="12" />
          </b-col>
          <b-col md="6">
            <div>Lamun</div>
          </b-col>
          <b-col md="6">
            <div class="form-check form-switch">
                    <input
                    disabled
                      v-model="form.ada_lamun"
                      class="form-check-input"
                      type="checkbox"
                      id="flexSwitchCheckDefault2"
                    />
                    <label
                      class="form-check-label"
                      for="flexSwitchCheckDefault2"
                      >{{
                        form.ada_lamun
                          ? "Ada"
                          : "Tidak Ada"
                      }}</label
                    >
                  </div>
          </b-col>
          <b-col md="12" class="divider-col">
            <hr class="style1" md="12" />
          </b-col>
          <b-col md="6">
            <div>Terumbu karang</div>
          </b-col>
          <b-col md="6">
            <div class="form-check form-switch">
                    <input
                    disabled
                      v-model="form.ada_terumbu_karang"
                      class="form-check-input"
                      type="checkbox"
                      id="flexSwitchCheckDefault2"
                    />
                    <label
                      class="form-check-label"
                      for="flexSwitchCheckDefault2"
                      >{{
                        form.ada_terumbu_karang
                          ? "Ada"
                          : "Tidak Ada"
                      }}</label
                    >
                  </div>
          </b-col>

          <b-col md="12">
            <div class="hr-sect">Hidro-oseanografi</div>
          </b-col>
          <!-- <b-col md="3">
                        
                        </b-col>
                        <b-col md="4">
                        
                        </b-col>
                        <b-col md="12" class="divider-col">
                            <hr class="style1" md="12">
                        </b-col> -->
          <b-col md="6 mt-2">
            <label>Arus</label>
            <div style="height: auto">
              <ckeditor disabled
              v-model="form.data_arus"
              :editor="wygEditor"
              v-validate="'required'"
              name="Arus"
              :class="{ input: true, 'is-danger': errors.has('Arus') }"
            ></ckeditor>
            <span class="text-danger" v-if="errors.has('Arus')">
              {{ errors.first("Arus") }}
            </span>
            </div>
          </b-col>
          <b-col md="6 mt-2">
            <label>Gelombang</label>
            <div style="height: auto">
              <ckeditor disabled
              v-model="form.data_gelombang"
              :editor="wygEditor"
              v-validate="'required'"
              name="Gelombang"
              :class="{ input: true, 'is-danger': errors.has('Gelombang') }"
            ></ckeditor>
            <span class="text-danger" v-if="errors.has('Gelombang')">
              {{ errors.first("Gelombang") }}
            </span>
            </div>
          </b-col>
          <b-col md="6 mt-2">
            <label>Pasang Surut</label>
            <div style="height: auto">
              <ckeditor disabled
              v-model="form.data_pasang_surut"
              :editor="wygEditor"
              v-validate="'required'"
              name="Pasang Surut"
              :class="{ input: true, 'is-danger': errors.has('Pasang Surut') }"
            ></ckeditor>
            <span class="text-danger" v-if="errors.has('Pasang Surut')">
              {{ errors.first("Pasang Surut") }}
            </span>
            </div>
          </b-col>
          <b-col md="6 mt-2">
            <label>Profil Dasar Laut</label>
            <div style="height: auto">
              <ckeditor disabled
              v-model="form.data_profil_dasar_laut"
              :editor="wygEditor"
              v-validate="'required'"
              name="Profil Dasar Laut"
              :class="{ input: true, 'is-danger': errors.has('Profil Dasar Laut') }"
            ></ckeditor>
            <span class="text-danger" v-if="errors.has('Profil Dasar Laut')">
              {{ errors.first("Profil Dasar Laut") }}
            </span>
            </div>
          </b-col>
          <b-col md="6 mt-2">
            <label>Kondisi Sosial Ekonomi Masyarakat</label>
            <div style="height: auto">
              <ckeditor disabled
              v-model="form.data_kondisi_masyarakat"
              :editor="wygEditor"
              v-validate="'required'"
              name="Kondisi Sosial Ekonomi Masyarakat"
              :class="{ input: true, 'is-danger': errors.has('Kondisi Sosial Ekonomi Masyarakat') }"
            ></ckeditor>
            <span class="text-danger" v-if="errors.has('Kondisi Sosial Ekonomi Masyarakat')">
              {{ errors.first("Kondisi Sosial Ekonomi Masyarakat") }}
            </span>
            </div>
          </b-col>
          <b-col md="6 mt-2">
            <label>Aksesibilitas</label>
            <div style="height: auto">
              <ckeditor disabled
              v-model="form.data_aksesibilitas"
              :editor="wygEditor"
              v-validate="'required'"
              name="Aksesibilitas"
              :class="{ input: true, 'is-danger': errors.has('Aksesibilitas') }"
            ></ckeditor>
            <span class="text-danger" v-if="errors.has('Aksesibilitas')">
              {{ errors.first("Aksesibilitas") }}
            </span>
            </div>
          </b-col>
        

          <template>
            <b-col md="12" class="divider-col">
              <hr class="style1" md="12" />
            </b-col>
            <b-col md="6">
              <p style="font-weight: 900; font-size: 17px">
                Persyaratan Lainnya
              </p>
            </b-col>
            <!-- <b-col md="3">
              <b-form-group>
                <b-form-file
                  placeholder="Choose a file or drop it here..."
                  drop-placeholder="Drop file here..."
                  plain
                  class="form-control"
                  v-model="file_5"
                  accept=".doc, .docx, .xlsx, .pdf"
                ></b-form-file>
                <span style="color: red; font-size: 12px"
                  >*Ukuran File Maksimal 5MB</span
                >
              </b-form-group>
            </b-col> -->
            <b-col md="3">
              <b-form-group>
                
                <!-- <b-button variant="success" v-if="form.file_persyaratan_lain" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                <b-button
                  variant="success"
                  v-if="form.file_persyaratan_lain == null"
                  disabled
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Tidak ada data"
                  class="text-white"
                  style="margin-right: 5px"
                  ><i class="fa fa-download" /> Download</b-button
                >
                <a
                  :href="form.file_persyaratan_lain"
                  v-else
                  type="button"
                  class="btn btn-success"
                  target="_blank"
                  rel="noopener noreferrer"
                  download
                  ><i class="fa fa-download" /> Download</a
                >
                <!-- <div class="form-check form-switch">
                                    <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault">
                                    <label class="form-check-label" for="flexSwitchCheckDefault">Sesuai</label>
                                </div> -->
              </b-form-group>
            </b-col>
            <b-col md="12" class="divider-col">
              <hr class="style1" md="12" />
            </b-col>
            
          </template>
          
        </b-row>
        <b-button variant="primary" class="float-end" @click="finish()">Selesai</b-button>
      </b-form>
    </Widget>
  </div>
</template>

<script>
import Vue from "vue";
import Widget from "@/components/Widget/Widget";
import vSelect from "vue-select";
import axios from "axios";
import Swal from "sweetalert2";
import { formatDate } from "../../../../helper/helpernew";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  components: {
    Widget,
    vSelect,
    formatDate,
  },
  data() {
    return {
      progress: 1,
      id_permohonan: localStorage.getItem("id_permohonan"),
      tipe: localStorage.getItem("tipe_pemohon"),
      baseapi: localStorage.getItem("baseapi"),
      user: JSON.parse(localStorage.getItem("user")),
      form: {},
      dataProvinsi: [],
      dataKabupaten: [],
      dataKecamatan: [],
      dataSkalaUsaha: ["Besar", "Menengah", "Mikro"],
      dataPSN: ["PSN", "Non PSN"],
      dataReklamasi: [
        { value: true, text: "Ya" },
        { value: false, text: "Tidak" },
      ],
      inputFiles: [],
      dataPerDokumen: [],
      dataUser: [],
      file_1: null,
      file_2: null,
      file_3: null,
      file_4: null,
      file_5: null,
      file_6: null,
      file_7: null,
      optionsBentukUsaha: [
        { value: "BUMN", text: "BUMN" },
        { value: "BUMD", text: "BUMD" },
        { value: "Lainnya", text: "Lainnya" },
      ],
      wygEditor: ClassicEditor,
    };
  },
  mounted() {
    this.getProvinsi();
    this.loadData();
  },
  methods: {
    simpanSelanjutnya() {
      this.$validator.validateAll().then((result) => {
        console.log("masuk");

        if (
          this.form.nik_pemohon != null &&
          this.form.nik_pemohon != "" &&
          this.form.npwp_pemohon != null &&
          this.form.npwp_pemohon != "" &&
          this.form.nama_pemohon != null &&
          this.form.nama_pemohon != "" &&
          this.form.jabatan_pemohon != null &&
          this.form.jabatan_pemohon != "" &&
          this.form.instansi_pemohon != null &&
          this.form.instansi_pemohon != "" &&
          this.form.alamat_pemohon != null &&
          this.form.alamat_pemohon != "" &&
          this.form.no_hp_pemohon != null &&
          this.form.no_hp_pemohon != "" &&
          this.form.no_telepon_pemohon != null &&
          this.form.no_telepon_pemohon != "" &&
          this.form.email_pemohon != null &&
          this.form.email_pemohon != "" &&
          this.form.provinsi != null &&
          this.form.provinsi != "" &&
          this.form.kabupaten != null &&
          this.form.kabupaten != "" &&
          this.form.kecamatan != null &&
          this.form.kecamatan != "" &&
          this.form.jenis_kegiatan != null &&
          this.form.jenis_kegiatan != "" &&
          this.form.nama_perairan != null &&
          this.form.nama_perairan != "" &&
          this.form.jenis_permohonan != null &&
          this.form.kedalaman != null &&
          this.form.kedalaman != ""
        ) {
          console.log("berhasil");
          this.simpanForm();
        }
      });
    },
    updateProgress(prevIndex, nextIndex) {
      console.log(prevIndex + ":" + nextIndex);
      if (nextIndex >= 0) {
        if (nextIndex == 1) {
        } else if (nextIndex == 2) {
        }
        Vue.set(this, "progress", nextIndex + 1);
      }
    },

    finish() {
      
        this.$router.push("/app/perizinan-umk");
        localStorage.removeItem("id_permohonan");
      
    },

    resetPNBP() {
      this.form.luas = null;
      this.form.panjang_konservasi = null;
      this.form.panjang_nonkonservasi = null;
    },

    loadData() {
      const id_permohonan = this.$route.params.id;
      axios
        .get(this.baseapi + "api/permohonan_umk/" + id_permohonan, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.form = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },
    getProvinsi() {
      axios
        .get(this.baseapi + "api/provinsi?sort=id,ASC", {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataProvinsi = response.data.data;
          this.getKabupaten();
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    getKabupaten() {
      axios
        .get(
          this.baseapi +
            "api/kabupaten?filter=nama_provinsi,=," +
            this.form.provinsi,
          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((response) => {
          this.dataKabupaten = response.data.data;
          this.getKecamatan();
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    getKecamatan() {
      axios
        .get(
          this.baseapi +
            "api/kecamatan?filter=nama_kabupaten,=," +
            this.form.kabupaten,
          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((response) => {
          this.dataKecamatan = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    async simpanUrl() {
      const id_permohonan = localStorage.getItem("id_permohonan");
      const formData = new FormData();
      formData.append("url_bahan_rapat", this.form.url_bahan_rapat);
      axios.post(
        this.baseapi + "api/permohonan_umk/" + id_permohonan,
        formData,
        {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        }
      );
    },

    format_date(val, format) {
      if (val) return formatDate(val, format);
    },

    async simpanForm() {
      const id_permohonan = localStorage.getItem("id_permohonan");
      this.form.tipe_pemohon = localStorage.getItem("tipe_pemohon");
      this.form.tanggal_permohonan = this.format_date(Date.now(), "YYYY-MM-DD");
      const formData = new FormData();
        formData.append("tanggal_permohonan", this.form.tanggal_permohonan);
        formData.append("nama_pemohon", this.form.nama_pemohon);
        formData.append("jabatan_pemohon", this.form.jabatan_pemohon);
        formData.append("instansi_pemohon", this.form.instansi_pemohon);
        formData.append("alamat_pemohon", this.form.alamat_pemohon);
        formData.append("nik_pemohon", this.form.nik_pemohon);
        formData.append("npwp_pemohon", this.form.npwp_pemohon);
        formData.append("no_hp_pemohon", this.form.no_hp_pemohon);
        formData.append("no_telepon_pemohon", this.form.no_telepon_pemohon);
        formData.append("email_pemohon", this.form.email_pemohon);
        formData.append("provinsi", this.form.provinsi);
        formData.append("kabupaten", this.form.kabupaten);
        formData.append("kecamatan", this.form.kecamatan);
        formData.append("jenis_kegiatan", this.form.jenis_kegiatan);
        // formData.append("reklamasi", this.form.reklamasi);
        formData.append("nama_perairan", this.form.nama_perairan);
        // formData.append("psn", this.form.psn);
        // formData.append("skala_usaha", this.form.skala_usaha);
        formData.append("jenis_permohonan", this.form.jenis_permohonan);
        formData.append("luas", this.form.luas);
        formData.append("panjang_konservasi", this.form.panjang_konservasi);
        formData.append(
          "panjang_nonkonservasi",
          this.form.panjang_nonkonservasi
        );
        formData.append("kedalaman", this.form.kedalaman);

        //Field UMK baru
        formData.append("tujuan_rencana_bangun", this.form.tujuan_rencana_bangun);
        formData.append("manfaat_rencana_bangun", this.form.manfaat_rencana_bangun);
        formData.append("kegiatan_eksisting_rencana_bangun", this.form.kegiatan_eksisting_rencana_bangun);
        formData.append("rencana_jadwal_rencana_bangun", this.form.rencana_jadwal_rencana_bangun);
        formData.append("batas_area_rencana_bangun", this.form.batas_area_rencana_bangun);
        formData.append("informasi_prl", this.form.informasi_prl);
        formData.append("ada_mangrove", this.form.ada_mangrove);
        formData.append("ada_lamun", this.form.ada_lamun);
        formData.append("ada_terumbu_karang", this.form.ada_terumbu_karang);
        formData.append("data_arus", this.form.data_arus);
        formData.append("data_gelombang", this.form.data_gelombang);
        formData.append("data_pasang_surut", this.form.data_pasang_surut);
        formData.append("data_profil_dasar_laut", this.form.data_profil_dasar_laut);
        formData.append("data_kondisi_masyarakat", this.form.data_kondisi_masyarakat);
        formData.append("data_aksesibilitas", this.form.data_aksesibilitas);
        
        //File
        if(this.file_1 != null){
          formData.append("file_kordinat", this.file_1);
        }

        if(this.file_2 != null){
          formData.append("file_rencana_tapak_rencana_bangun",this.file_2);
        }

        if(this.file_5 != null){
          formData.append("file_persyaratan_lain", this.file_5);
        }
        
        
        // formData.append("file_permohonan",this.file_7);



      if (id_permohonan != null) {
        // console.log(this.cabang);
        // return;
        
        axios
          .post(
            this.baseapi + "api/permohonan_umk/" + id_permohonan,
            formData,
            {
              headers: {
                Authorization: `Bearer ` + this.user.accessToken,
              },
            }
          )
          .then((response) => {
            let btn = document.getElementById("selanjutnya");
            btn?.click();
            Swal.fire("Berhasil", "" + response.data.message + "", "success");
            
              this.$router.push("/app/permohonan/umk");
            localStorage.removeItem("id_permohonan");
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        axios
          .post(this.baseapi + "api/permohonan_umk", formData, {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          })
          .then((response) => {
            this.$router.push("/app/permohonan/umk");
            localStorage.removeItem("id_permohonan");
            Swal.fire("Berhasil", "" + response.data.message + "", "success");
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    simpanFile(jenis) {
      const id_permohonan = localStorage.getItem("id_permohonan");
      let formData = new FormData();
      if (jenis == "kordinat") {
        formData.append("file_kordinat", this.file_1);
      } else if (jenis == "bangunan") {
        formData.append(
          "file_rencana_tapak_rencana_bangun",
          this.file_2
        );
      } else if (jenis == "prl") {
        formData.append("file_informasi_prl", this.file_3);
      } else if (jenis == "kondisi") {
        formData.append("file_data_kondisi_terkini", this.file_4);
      } else if (jenis == "lain") {
        formData.append("file_persyaratan_lain", this.file_5);
      } else if (jenis == "reklamasi") {
        formData.append("file_persyaratan_reklamasi", this.file_6);
      } else if (jenis == "surat") {
        formData.append(
          "filename_surat_permohonan_perizinan_nonberusaha",
          this.file_7
        );
      }

      axios
        .post(
          this.baseapi + "api/permohonan_umk/" + id_permohonan,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((response) => {
          this.$toasted.success("Berhasil Diunggah");
          this.file_1 = null;
          this.file_2 = null;
          this.file_3 = null;
          this.file_4 = null;
          this.file_5 = null;
          this.file_6 = null;
          this.file_7 = null;
          this.loadData();
          return response;
        })
        .catch((error) => {
          this.$toasted.danger("Gagal Diunggah");
          return error;
        });
    },
    onChangeInputFiles(e) {
      const files = [];
      let i = 0;
      for (i; i < e.target.files.length; i += 1) {
        files.push(e.target.files[i]);
      }

      Vue.set(this, "inputFiles", files);
    },
    removeFiles() {
      Vue.set(this, "inputFiles", []);
    },
  },
};
</script>

<style scoped>
.ck-editor__editable {
    height: 100px;
}
</style>
